package com.milta.core.localization.translations.en

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Loading address",
    emptyMessage = "To optimize the route, tell us where your drivers load the goods. It will be saved for your next routes.",
    selectPlaceholder = "Choose a loading address",
    sheetSubtitle = "Where your drivers pick up the goods.",
    startPointBadge = "Starting point",
    newAddressAction = "New address",
    mobileSearchPlaceholder = "Street, number, town",
    webSearchPlaceholder = "Search for an address…",
    deleteDialogTitle = "Delete this address?",
    deleteDialogMessage = "“%s” will no longer be suggested. Routes already created are not affected.",
    webSubmitBlockedHint = "Choose a loading address to optimize.",
    errorRequired = "Choose a loading address.",
)
